import React, {
  FC, useMemo, useState, useEffect,
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Card } from 'reactstrap';
import _ from 'lodash';
import Isvg from 'react-inlinesvg';

import ArrowRightIcon from 'app/images/icons/arrow-right.svg';

import SectionGroup from 'app/components/general/SectionGroup';

import * as teamPaymentRequestsActions from 'app/ducks/teamPaymentRequests/actions';
import PaymentRequestsTable from 'app/components/teamPaymentRequests/PaymentRequestsTable';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as teamPaymentRequestsSelectors from 'app/ducks/teamPaymentRequests/selectors';
import * as organisationsSelectors from 'app/ducks/organisations/selectors';
import { ITeamPaymentRequestsSelector } from 'app/ducks/teamPaymentRequests/types';

function selector(state): any {
  return {
    appReady: loadingSelectors.appReady(state),
    teamPaymentRequests: teamPaymentRequestsSelectors.getTeamPaymentRequests(state),
    currentOrganisation: organisationsSelectors.getCurrentOrganisation(state),
    isLoading: state.payments.isLoading,
    errors: { ...state.teamPaymentRequests.backendErrors },
  };
}

const actionCreators = _.merge(teamPaymentRequestsActions);

interface IProps {
  groupId: string;
  teamId: string;
  appReady: any;
  teams: ITeamsSelector;
  teamPaymentRequests: ITeamPaymentRequestsSelector;
  actions: any;
  currentOrganisation: any;
  isLoading: boolean;
  errors: any;
  filterStatus: string;
}

interface IState {
  numberOfCards: number;
}

const DashboardActivePaymentRequests: FC<IProps> = (props: IProps = {
  groupId: undefined,
  teamId: undefined,
  teamPaymentRequests: {},
  teams: {},
  actions: undefined,
  currentOrganisation: {},
  isLoading: false,
  appReady: false,
  errors: {},
  filterStatus: 'pending',
}) => {
  let parsedFilterConfig = {
    teamId: props.teamId,
    status: props.filterStatus,
    overdue: undefined,
  };
  if (props.filterStatus === 'overdue') {
    parsedFilterConfig = {
      teamId: props.teamId,
      status: 'pending',
      overdue: true,
    };
  }

  return (
    <SectionGroup title="Active Payment Requests" noBorder>
      <div className="row">
        <div className="col">
          <PaymentRequestsTable
            teamPaymentRequestsById={props.teamPaymentRequests.teamPaymentRequestsById}
            teamPaymentRequestIds={props.teamPaymentRequests.teamPaymentRequestIds}
            pagination={props.teamPaymentRequests.pagination}
            appReady={props.appReady}
            actions={props.actions}
            saveFilters={false}
            createReminder={undefined}
            persistentFilterConfig={parsedFilterConfig}
            isLoading={props.teamPaymentRequests.isLoading}
            selectTeamPaymentRequest={props.actions.selectTeamPaymentRequest}
          />
        </div>
      </div>
      <div>
        <div className="row with-margin-top-10">
          <div className="col text-right">
            <div className="d-inline-block">
              <Link className="btn-2 btn-thin d-flex align-content-center" to="/payment-requests">
                <span className="d-inline-block">View all payment requests</span>
                {' '}
                <Isvg className="d-inline-block right-arrow-icon" src={ArrowRightIcon} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </SectionGroup>
  );
};
export default connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))(DashboardActivePaymentRequests);
